// When a viewer keyboard shortcut must NOT fire.
//
// The viewer answers single letters - F frame, H home, G grid, I isolate,
// S screenshot, M measure, C section, D display - and listens on the
// window. So typing "surface" into an issue title on a viewer page used
// to take a screenshot, frame the selection and toggle the section plane
// on the way past (leader, 2026-09-19).
//
// Its own file so the rule is testable without standing up a viewer, and
// so every shortcut owner uses the same one.
export function shouldIgnoreKey(e, doc = typeof document !== 'undefined' ? document : null) {
  if (!e) return true;
  // A shortcut is a bare letter; anything with a modifier belongs to the
  // browser or the OS.
  if (e.ctrlKey || e.metaKey || e.altKey) return true;
  const t = e.target;
  const tag = t && t.tagName ? String(t.tagName).toLowerCase() : '';
  if (tag === 'input' || tag === 'textarea' || tag === 'select') return true;
  if (t && t.isContentEditable) return true;
  // A dialog counts as typing even before its field takes focus: the
  // person is filling something in, not driving the model behind it.
  if (doc && typeof doc.querySelector === 'function') {
    try {
      if (doc.querySelector('.ant-modal-wrap:not([style*="display: none"]), .ant-drawer-open, .modal.show, [role="dialog"][aria-modal="true"]')) return true;
    } catch (err) { /* a document that cannot be queried is not a dialog */ }
  }
  return false;
}

export default shouldIgnoreKey;
